import { Status } from "../Config/Status.js";
import { Options } from "../Config/Options.js";

const Animation = {
  targetClass: 'js-anime',
  options: {
    shiftPoint : Options.breakpoint.tb,
    offset : {pc: 10, sp: 10},
  },
  update() {
    const targetElms = document.getElementsByClassName(Animation.targetClass);
    for(const targetElm of targetElms) {
      let shift;
      const position = targetElm.getBoundingClientRect().top;

      if (Status.winWidth < this.options.shiftPoint) {
        shift = Status.winHeight / this.options.offset.sp;
      } else {
        shift = Status.winHeight / this.options.offset.pc;
      }
      if(targetElm.dataset.shift) {
        shift = Status.winHeight * targetElm.dataset.shift;
      }
      if(position < Status.winHeight - shift) {
        targetElm.classList.add(Options.actAnime); 
      }
    }
  },
  reset() {
    const targetElms = document.getElementsByClassName(Animation.targetClass);
    for(const targetElm of targetElms) {
      targetElm.classList.remove(Options.actAnime);
    }
  }
}

export default Animation;